<template>
  <el-dialog
    :title="`安全库存查看`"
    :visible.sync="visible"
    width="900px"
    append-to-body
    @closed="handleClosed">
    <div class="search-form">
      <ent-product-auto-select
        v-model="config.productId"
        :productTypes="[1,2,3,9]"
        :callback="() => {handleCurrentChange(1)}" />
    </div>
    <el-table
      ref="table"
      v-loading="loading"
      border
      :row-class-name="tableRowClassName"
      :data="list">
      <el-table-column
        :resizable="false"
        min-width="150"
        label="商品名称"
        prop="productName">
        <template slot-scope="{row}">
          <el-tag
            v-if="row.stockBalance < row.lowQuota"
            type="danger">库存不足</el-tag>
          <span>{{ row.productName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :resizable="false"
        min-width="150"
        label="仓库名称"
        prop="warehouseName"></el-table-column>
      <el-table-column
        :resizable="false"
        label="仓库编号"
        width="80"
        prop="warehouseNo"></el-table-column>
      <el-table-column
        :resizable="false"
        width="100"
        label="当前库存">
        <template slot-scope="{row}">
          {{ row.stockBalance }}{{ row.measureUnit | measureUnitName() }}
        </template>
      </el-table-column>
      <el-table-column
        :resizable="false"
        width="100"
        label="安全库存">
        <template slot-scope="{row}">
          {{ row.lowQuota }}{{ row.measureUnit | measureUnitName() }}
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <div slot="footer">
      <el-button @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import EntProductAutoSelect from '@/components/business/ent-product-auto-select.vue'
export default {
  name: 'SafetyStocksInfoModal',
  components: { EntProductAutoSelect },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        productId: null,
        productType: null
      },
      list: [],
      total: 0,
      visible: false
    }
  },
  methods: {
    tableRowClassName({ row }) {
      if (row.stockBalance < row.lowQuota) {
        return 'warning-row'
      }
      return ''
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.config.productId = null
      this.config.productType = null
      this.config.pageNum = 1
      this.list = []
      this.total = 0
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('product/getsafetystocks', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row = {}) {
      this.config.productId = row.productId
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus">
  .el-table .warning-row {
    background: oldlace !important;
  }
</style>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
